import { ArrowDropDown } from '@mui/icons-material';
import { Toolbar, Box, styled, InputBase } from '@mui/material';

const CustomizedToolbar = styled(Toolbar)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: 0,
});

const CustomizedSearchDiv = styled(Box)({
  border: '2px solid #E2E3E5',
  borderRadius: '8px',
  width: '25%',
});

const IconsDiv = styled(Box)({
  width: '99.5%',
  display: 'flex',
  // flexDirection: 'row',
  alignItems: 'center',
  // justifyContent: 'right',
  justifyContent: 'space-between',
});

const CustomizedArrowIcon = styled(ArrowDropDown)({
  fontSize: '30px',
});

const CustomizedInputBase = styled(InputBase)({
  ml: 1,
  flex: 1,
});

export {
  CustomizedToolbar,
  IconsDiv,
  CustomizedArrowIcon,
  CustomizedInputBase,
  CustomizedSearchDiv,
};
